import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { StandardTrainingCategoryModel } from "../../models/standard-training-category/standard-training-category.model";
import { Configuration } from "src/assets/Configuration";
import { StandardTrainingCategoryCreationAndUpdateModel } from "src/app/models/standard-training-category/standard-training-category-creation-and-update.model";
import { StandardTrainingCategoryOverviewModel } from "src/app/models/standard-training-category/standard-training-category-overview.model";

@Injectable({
  providedIn: 'root'
})
export class StandardTrainingCategoryAdminService {

  constructor(
    private httpClient: HttpClient
  ) {}

  getAllStandardTrainingCategories(): Observable<StandardTrainingCategoryModel[]> {
    return this.httpClient.get<StandardTrainingCategoryModel[]>(
      Configuration.getApiBaseUrl() + '/standard-training-category/admin',
      { withCredentials: true }
    );
  }

  getStandardTrainingCategoriesOverview(
    languageCode: string
  ): Observable<StandardTrainingCategoryOverviewModel[]> {
    const params = new HttpParams()
      .set('languageCode', languageCode);

    return this.httpClient.get<StandardTrainingCategoryOverviewModel[]>(
      Configuration.getApiBaseUrl() + '/standard-training-category/admin/overview',
      { withCredentials: true, params }
    );
  }

  getStandardTrainingCategory(
    id: string
  ): Observable<StandardTrainingCategoryModel> {
    return this.httpClient.get<StandardTrainingCategoryModel>(
      Configuration.getApiBaseUrl() + '/standard-training-category/admin/' + id,
      { withCredentials: true }
    );
  }

  addStandardTrainingCategory(
    model: StandardTrainingCategoryCreationAndUpdateModel
  ): Observable<StandardTrainingCategoryModel> {
    return this.httpClient.post<StandardTrainingCategoryModel>(
      Configuration.getApiBaseUrl() + '/standard-training-category/admin',
      model,
      { withCredentials: true }
    );
  }

  updateStandardTrainingCategory(
    id: string,
    model: StandardTrainingCategoryCreationAndUpdateModel
  ): Observable<StandardTrainingCategoryModel> {
    return this.httpClient.post<StandardTrainingCategoryModel>(
      Configuration.getApiBaseUrl() + '/standard-training-category/admin/' + id,
      model,
      { withCredentials: true }
    );
  }

  deleteStandardTrainingCategory(id: string): Observable<void> {
    return this.httpClient.delete<void>(
      Configuration.getApiBaseUrl() + '/standard-training-category/admin/' + id,
      { withCredentials: true }
    );
  }
}